import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import procubed from '../asset/procubed1.png';
import lockIcon from '../asset/password.svg';
import userIcon from '../asset/user.svg';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const API_URL = `https://${window.location.hostname}/api`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const payload = { username, password };
    console.log("Sending login payload:", payload);

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.ok) {
        const tabId = Math.random().toString(36).substring(2);

        sessionStorage.setItem("activeTab", tabId);
        sessionStorage.setItem(`username_${tabId}`, username);
        sessionStorage.setItem(`role_${tabId}`, data.role);
        console.log("Login Role : ", data.role);
        sessionStorage.setItem(`userId_${tabId}`, data.id);
        sessionStorage.setItem(`token_${tabId}`, data.token);
        if (data.company) sessionStorage.setItem(`company_${tabId}`, data.company);
        if (data.address) sessionStorage.setItem(`address_${tabId}`, data.address);

        if (onLogin) onLogin(username, data.role);

        window.location.href = "/";
      } else {
        setError(data.message || "Invalid username or password");
      }

    } catch (err) {
      console.error(err);
      setError("Server error. Try again.");
    }
  };

  return (
    <div className="login-container d-flex align-items-center justify-content-center min-vh-100 bg-gradient px-3">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
            <div className="card shadow-lg border-0 rounded-lg hover-card">

              <div className="card-header text-white text-center py-3 py-md-4">
                <div className="logo-container mb-3">
                  <img src={procubed} alt="Logo" className="img-fluid" style={{ maxWidth: '80px' }} />
                </div>
                <h2 className="mb-0 fs-4">SIGN IN</h2>
              </div>

              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>

                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                    <label><img src={userIcon} class="icon" /> Email</label>
                  </div>

                  <div className="form-floating mb-4 position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label><img src={lockIcon} alt="" className="me-2" style={{ width: '16px', height: '16px' }} /> Password</label>

                    <button
                      type="button"
                      className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                    </button>
                  </div>

                  {error && <div className="alert alert-danger">{error}</div>}

                  <button className="btn btn-primary w-100">
                    <i className="fas fa-sign-in-alt me-2"></i> Sign In
                  </button>

                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
